/**
 * Navegación del panel admin agrupada por área (alineado con Notion Javiland).
 * badgeKey: clave en operationsSummary.badges
 * queue: filtro inicial para OrdersManagement
 */
export const ADMIN_NAV_AREAS = [
  {
    id: 'today',
    label: 'Mi día',
    items: [
      { id: 'dashboard', label: 'Centro de mando', icon: 'fa-gauge-high', badgeKey: null }
    ]
  },
  {
    id: 'operations',
    label: 'Operaciones',
    items: [
      { id: 'orders-dropshipping', section: 'orders', label: 'Cola dropshipping', icon: 'fa-truck-fast', badgeKey: 'dropshipping', queue: 'dropshipping' },
      { id: 'packaging', section: 'packaging', label: 'Empaque Chía', icon: 'fa-box-open', badgeKey: 'packaging', processKey: 'chk001' },
      { id: 'orders-shipping', section: 'orders', label: 'Guías y envío', icon: 'fa-shipping-fast', badgeKey: null, queue: 'shipping_guide' },
      { id: 'orders', section: 'orders', label: 'Todas las órdenes', icon: 'fa-shopping-cart', badgeKey: 'orders', queue: '' }
    ]
  },
  {
    id: 'sales',
    label: 'Ventas',
    items: [
      { id: 'products', section: 'products', label: 'Productos', icon: 'fa-store', badgeKey: null },
      { id: 'gp-projects', section: 'gp-projects', label: 'Proyectos GP', icon: 'fa-handshake', badgeKey: null },
      { id: 'canal-tienda', section: 'canal-tienda', label: 'Canal tienda', icon: 'fa-truck-ramp-box', badgeKey: null },
      { id: 'cotizaciones', section: 'cotizaciones', label: 'Cotizaciones B2B', icon: 'fa-file-signature', badgeKey: null }
    ]
  },
  {
    id: 'finance',
    label: 'Finanzas',
    items: [
      { id: 'invoices', section: 'invoices', label: 'Facturas Numbers', icon: 'fa-file-invoice', badgeKey: 'invoices', processKey: 'sop_facturacion' }
    ]
  },
  {
    id: 'marketing',
    label: 'Marketing',
    items: [
      { id: 'marketing-hub', section: 'marketing-hub', label: 'Tráfico y plan', icon: 'fa-chart-pie', badgeKey: null },
      { id: 'testimonios', section: 'testimonios', label: 'Testimonios', icon: 'fa-comments', badgeKey: 'testimonials' },
      { id: 'members', section: 'members', label: 'Miembros comunidad', icon: 'fa-users', badgeKey: null }
    ]
  },
  {
    id: 'services',
    label: 'Servicios',
    items: [
      { id: 'bienestar-bookings', section: 'bienestar-bookings', label: 'Reservas bienestar', icon: 'fa-spa', badgeKey: null }
    ]
  },
  {
    id: 'system',
    label: 'Sistema',
    collapsedDefault: true,
    items: [
      { id: 'users', section: 'users', label: 'Usuarios', icon: 'fa-user-cog', badgeKey: null },
      { id: 'settings', section: 'settings', label: 'Configuración', icon: 'fa-cog', badgeKey: null },
      { id: 'logs', section: 'logs', label: 'Logs', icon: 'fa-clipboard-list', badgeKey: null }
    ]
  }
];

export function resolveAdminNavItem(section, queue = '') {
  for (const area of ADMIN_NAV_AREAS) {
    for (const item of area.items) {
      const itemSection = item.section || item.id;
      if (itemSection === section && (item.queue ?? '') === (queue ?? '')) {
        return item;
      }
    }
  }
  if (section === 'dashboard') {
    return { id: 'dashboard', section: 'dashboard', label: 'Centro de mando' };
  }
  return { id: section, section, label: section };
}
